import fetchWrapper from "../useFetch";
import Cookies from "universal-cookie";

const baseURL = process.env.NEXT_PUBLIC_BASE_CMS;
const cookies = new Cookies();

export const signup = async (data) => {
  //const response = await fetch(`${baseURL}/dj-rest-auth/registration/`, {
  const response = await fetch(`${baseURL}/api/user/account/create`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    body: new URLSearchParams(data),
    // body: JSON.stringify(data),
  }).catch((err) => console.error(err));
  return response;
};

export const login = async (data) => {
  // const response = fetch(`${baseURL}/api/login`, {
  const response = await fetch(`${baseURL}/api/user/account/login`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    body: new URLSearchParams(data),
  });

  return response;
};

// user/account/migrate

export const migrate = async (data) => {
  // const response = fetch(`${baseURL}/api/login`, {
  const response = await fetch(`${baseURL}/api/user/account/migrate`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    body: new URLSearchParams(data),
  });

  return response;
};

export const logout = async () => {
  // const response = fetch(`${baseURL}/api/login`, {
  const response = await fetch(`${baseURL}/api/user/account/logout`, {
    method: "GET",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    // body: new URLSearchParams(data),
  });

  return response;
};

export const deleteAccount = async () => {
  // const response = fetch(`${baseURL}/api/login`, {
  const response = await fetch(`${baseURL}/api/user/account/delete`, {
    method: "GET",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    // body: new URLSearchParams(data),
  });

  return response;
};

export const changePassword = async (data) => {
  const response = await fetch(`${baseURL}/api/user/account/change_password`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    body: new URLSearchParams(data),
  });

  return response;
};

export const changePasswordRequest = async (data) => {
  // const response = fetch(`${baseURL}/api/login`, {
  const response = await fetch(`${baseURL}/api/user/account/new_password`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    body: new URLSearchParams(data),
  });

  return response;
};

export const submitContactForm = async (data) => {
  const response = await fetch(`${baseURL}/api/user/account/email_support`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRFToken": cookies.get("boho_csrf"),
      "X-CSRF-Token": cookies.get("boho_csrf"),
      // "X-CSRFToken": "",
    },
    credentials: "include",
    body: new URLSearchParams(data),
  });

  return response; 
}
